import { useEffect } from 'react';

const SEO = ({ 
  title = 'Ambulante Pflege Großstadtherzen', 
  description = 'Professionelle ambulante Pflege mit Herz in Leipzig und Halle (Saale).',
  keywords = 'ambulante Pflege, Pflegedienst Leipzig, Pflegedienst Halle',
  canonicalPath = '/'
}) => {
  useEffect(() => {
    // Update document title - simplified to just the main name
    document.title = 'Ambulante Pflege Großstadtherzen';
    
    // Update meta description
    const metaDescription = document.querySelector('meta[name="description"]');
    if (metaDescription) {
      metaDescription.setAttribute('content', description);
    }
    
    // Update meta keywords
    let metaKeywords = document.querySelector('meta[name="keywords"]');
    if (metaKeywords) {
      metaKeywords.setAttribute('content', keywords);
    }
    
    // Update OG tags
    const ogTitle = document.querySelector('meta[property="og:title"]');
    if (ogTitle) {
      ogTitle.setAttribute('content', 'Ambulante Pflege Großstadtherzen');
    }
    
    const ogDescription = document.querySelector('meta[property="og:description"]');
    if (ogDescription) {
      ogDescription.setAttribute('content', description);
    }
    
    // Update canonical URL
    let canonical = document.querySelector('link[rel="canonical"]');
    if (canonical) {
      canonical.setAttribute('href', `https://www.grossstadtherzen.de${canonicalPath}`);
    }
    
  }, [title, description, keywords, canonicalPath]);

  return null;
};

export default SEO;
